module.exports = __webpack_public_path__ + "media/offers_icons/przyczepy-blue-c11a7066.svg";